import React, { Component } from 'react';
import { Modal, Header, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';

import { editHouseholdCategoricalType } from '../state/householdCategoricalTypes/actions';
import { submitForm } from 'State/forms/actions';

import EditCaseTypeForm from './EditCaseTypeForm';
import { SubmitType } from '../helpers';
import { EDIT_CASE_TYPE_FORM_NAME } from 'Common/FormEnum';

class HouseHoldEditModalContainer extends Component {
  handleSubmit = caseType => {
    const submitType = this.props.isAdd ? SubmitType.Add : SubmitType.Edit;
    this.props.editHouseholdCategoricalType(caseType, submitType);
  };

  onSaveClick = () => {
    this.props.submitForm(EDIT_CASE_TYPE_FORM_NAME);
  };

  render() {
    const { open, caseType, isAdd, submitting, onClose } = this.props;
    const title = isAdd ? 'New Case Type' : `Edit - ${caseType.Description}`;

    return (
      <Modal
        open={open}
        onClose={onClose}
        closeIcon
        size={'mini'}
        closeOnRootNodeClick={false}
      >
        <Header content={title} icon={'signup'} />
        <Modal.Content className="p-t-0">
          <EditCaseTypeForm
            onSubmit={this.handleSubmit}
            initialValues={caseType}
            isAdd={isAdd}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={this.onSaveClick}
            inverted
            color="orange"
            size="big"
            content="Save"
            loading={submitting}
            disabled={submitting}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = ({ ControlInformationState }) => {
  const { householdCategoricalTypes } = ControlInformationState;

  return {
    submitted: householdCategoricalTypes.submitted,
    submitting: householdCategoricalTypes.submitting,
  };
};

const mapDispatchToProps = {
  editHouseholdCategoricalType,
  submitForm,
};

export const HouseHoldEditModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(HouseHoldEditModalContainer);



// WEBPACK FOOTER //
// ./src/pages/controlinformation/components/HouseHoldEditModal.js